import React from 'react';
import PropTypes from 'prop-types';
import { Button, Popover } from '@material-ui/core';

import useStyles from '../useStyles';

const Panel = ({ anchorEl, open, labels, chips, onClose, onApply, children }) => {
  const classes = useStyles();

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      classes={{ paper: classes.panel }}
      PaperProps={{ role: 'dialog', 'aria-label': labels.title }}
    >
      {labels.title && <div className={classes.title}>{labels.title}</div>}
      <div className={classes.controls}>{children}</div>
      {!!chips.length && (
        <div className={classes.quick}>
          <span className={classes.caption}>{labels.quick}:</span>
          <div className={classes.chips}>
            {chips.map(({ label, onClick }) => (
              <button key={label} type="button" className={classes.chip} onClick={onClick}>
                {label}
              </button>
            ))}
          </div>
        </div>
      )}
      <div className={classes.actions}>
        <Button variant="outlined" color="secondary" onClick={onClose}>
          {labels.cancel}
        </Button>
        <Button variant="outlined" color="primary" onClick={onApply}>
          {labels.apply}
        </Button>
      </div>
    </Popover>
  );
};

Panel.propTypes = {
  anchorEl: PropTypes.instanceOf(Element),
  open: PropTypes.bool.isRequired,
  labels: PropTypes.shape({
    title: PropTypes.string,
    quick: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
    apply: PropTypes.string.isRequired,
  }).isRequired,
  chips: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
  onApply: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

Panel.defaultProps = {
  anchorEl: null,
};

export default Panel;
